import { Text } from '@wix/design-system';
import React from 'react';
import { showErrorModal } from '../../../components/modals/show-error-modal';
import { getEditorCapabilitiesForHost } from '../../../utils/editor-host-to-editor-type';
export const getErrorDomOrderModalProps = (t, editorHost) => {
  const {
    usesClassicModalChrome
  } = getEditorCapabilitiesForHost(editorHost);
  return {
    content: usesClassicModalChrome ? t('accessibility-wizard.rules-list.dom-order.error-modal.content') : /*#__PURE__*/React.createElement(Text, null, t('accessibility-wizard.rules-list.dom-order.error-modal.content')),
    primaryButtonText: t('accessibility-wizard.rules-list.dom-order.error-modal.primary-button'),
    secondaryButtonText: t('accessibility-wizard.rules-list.dom-order.error-modal.secondary-button'),
    skin: 'destructive',
    title: t('accessibility-wizard.rules-list.dom-order.error-modal.title')
  };
};
export const showDomOrderErrorModal = async _ref => {
  let {
    handleTryAgain,
    handleCancel,
    a11yWizardAdapter,
    t,
    fixOption,
    editorHost
  } = _ref;
  await showErrorModal({
    ...getErrorDomOrderModalProps(t, editorHost),
    a11yWizardAdapter,
    editorHost,
    primaryButtonOnClick: () => handleTryAgain(fixOption),
    secondaryButtonOnClick: handleCancel
  });
};
//# sourceMappingURL=show-dom-order-error-modal.js.map